/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询该巡演项目是否被我收藏
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  tourId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/tour/${tourId}/exist`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
